module.exports = __webpack_public_path__ + "static/588744adc0d6cea20cece144059073f5bf0beb15d1f9cea59944e418f52df179-36178199f77ff3484f74e44e6a1a50d2.jpeg";